import { render, staticRenderFns } from "./aRestaurantSalesResume.vue?vue&type=template&id=6dbc2ede"
import script from "./aRestaurantSalesResume.vue?vue&type=script&lang=js"
export * from "./aRestaurantSalesResume.vue?vue&type=script&lang=js"
import style0 from "./aRestaurantSalesResume.vue?vue&type=style&index=0&id=6dbc2ede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
